import { useEffect } from "react";
import { COMPANY, pageUrl } from "@/data/site";

// Atualiza title, meta description e canonical no client (complementa o SEO estático em /public)
export const SEO = ({ title, description, path = "" }) => {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${COMPANY.site}${pageUrl(path)}`);
  }, [title, description, path]);
  return null;
};
